import { Box, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MyAccountTitle } from '../../../routes/AccountPage';
import AccessForm from './AccessForm';

const AccountAccess = () => {
  const { t } = useTranslation();
  const personalInfo = useSelector((state) => state.user.personalInfo);

  if (!personalInfo) return null;

  return (
    <Box
      sx={{
        flex: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <MyAccountTitle>{t('myAccount.accessData.title')}</MyAccountTitle>
      <Box marginBottom={1.5}>
        <Typography variant='small'>
          <Trans i18nKey='myAccount.accessData.text' />
        </Typography>
      </Box>
      <AccessForm />
    </Box>
  );
};

export default AccountAccess;
